import { Routes, Route, Navigate, useParams, useLocation } from 'react-router-dom';
import { ProjectPage } from './pages/ProjectPage';
import { AuthPage } from './pages/AuthPage';
import { AuthVerifyPage } from './pages/AuthVerifyPage';
import { FAQPage } from './pages/FAQPage';
import { AdminApp } from './AdminApp';
import { useAuth } from './hooks/useAuth';
import { useProject } from './hooks/useProject';
import { Loader2 } from 'lucide-react';

function ProjectFAQPage() {
  const { jiraKey } = useParams<{ jiraKey: string }>();
  const { project, loading, error } = useProject(jiraKey || '');

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary-600 mx-auto mb-4" />
          <p className="text-gray-600">Loading project information...</p>
        </div>
      </div>
    );
  }

  if (error || !project) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600">Project not found or error loading project.</p>
        </div>
      </div>
    );
  }

  return <FAQPage />;
}

function App() {
  const location = useLocation();
  
  console.log('App component - current pathname:', location.pathname);

  // Check if we're on an admin route using React Router location
  const isAdminRoute = location.pathname.startsWith('/admin');
  
  console.log('App component - isAdminRoute:', isAdminRoute);

  // If it's an admin route, don't use customer auth at all
  if (isAdminRoute) {
    console.log('App component - rendering admin route');
    return <AdminApp />;
  }

  console.log('App component - rendering customer app');
  // For all other routes, use customer auth
  return <CustomerApp />;
}

function CustomerApp() {
  console.log('CustomerApp component - rendering');
  const { loading } = useAuth();
  
  console.log('CustomerApp component - loading:', loading);

  if (loading) {
    console.log('CustomerApp component - showing loading state');
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary-600 mx-auto mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Project route - let ProjectPage handle authentication */}
      <Route path="/project/:jiraKey" element={<ProjectPage />} />
      
      {/* FAQ pages */}
      <Route path="/help" element={<FAQPage />} />
      <Route path="/project/:jiraKey/help" element={<ProjectFAQPage />} />
      
      {/* Auth page */}
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/auth/verify" element={<AuthVerifyPage />} />
      
      {/* Default redirect */}
      <Route path="*" element={<Navigate to="/auth" replace />} />
    </Routes>
  );
}

export default App;
